import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../../../app/guards'
import { ClaimPrintPage } from '../../../../../../features/projects/contracting/claim-print-page'
import { claimPrintSearchSchema } from '../../../../../../features/projects/contracting/claims-search'

/** The payment application and the interim payment certificate of a claim, EN/AR. */
export const Route = createFileRoute('/_app/projects/$projectId/claims/$claimId/print')({
  staticData: { crumb: 'projectClaimPrint' },
  validateSearch: claimPrintSearchSchema,
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'projects.contract', 'projects.financials'),
  component: ClaimPrintPage,
})
